/**
 * 导航信息数据增强器
 * 优先级：1（最高）
 * 职责：自动注入 referrer、source_page、session_id、navigation_path
 */

import { DataEnricher, EnrichContext } from "./types";
import { NavigationContext } from "../context/NavigationContext";

export class NavigationEnricher implements DataEnricher {
  name = "NavigationEnricher";
  priority = 1; // 最高优先级，所有埋点都需要导航信息

  shouldEnrich(context: EnrichContext): boolean {
    // 所有埋点都需要导航信息
    return context.options?.enableNavigation !== false;
  }

  enrich(context: EnrichContext): Record<string, any> {
    const { trackData } = context;
    const navContext = NavigationContext.get();

    if (!navContext) {
      // 如果导航上下文不存在，使用 document.referrer 作为兜底
      if (!trackData.referrer && typeof document !== "undefined") {
        trackData.referrer = document.referrer || "";
      }
      if (!trackData.source_page && typeof document !== "undefined") {
        trackData.source_page = document.referrer || "";
      }
      return trackData;
    }

    // 自动注入 referrer 和 source_page（如果未设置）
    if (!trackData.referrer) {
      trackData.referrer = navContext.referrer;
    }
    if (!trackData.source_page) {
      trackData.source_page = navContext.source_page;
    }

    // 注入会话信息
    trackData.session_id = navContext.session_id;
    trackData.session_start_url = navContext.session_start_url;

    // 注入导航路径（用于数据分析）
    const navPath = NavigationContext.getNavigationPath();
    if (navPath.length > 0) {
      trackData.navigation_path = navPath.join(" > ");
    }

    // 开发环境日志
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.log("[NavigationEnricher]:", {
        referrer: trackData.referrer,
        source_page: trackData.source_page,
        session_id: trackData.session_id,
        path: trackData.navigation_path,
      });
    }

    return trackData;
  }
}
